import Link from "next/link";
import { useState, useEffect } from "react";
import { WidgetShare } from "../../SocialButtons";
import styles from "../../../styles/candidate/parts/ContestWidget.module.scss";

const basePath = process.env.SITE_URL;
const ContestWidget = ({ contestName, data, candidates, url }) => {
  const [fromIndex, setFromIndex] = useState(0);
  const [toIndex, setToIndex] = useState(11);
  const [showAll, setIsShowAll] = useState(false);
  const [isMounted, setIsMounted] = useState(true);

  let parseBallotToInt = parseInt(data?.candidacy_set[0].ballot_no);
  let lastEleven = candidates?.results.slice(
    Math.max(candidates.results.length - 11, 1)
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (isMounted) {
      setIsShowAll(false);
      if (data) {
        setIsMounted(true);
        let filterBallotNo = lastEleven?.filter(
          (res) => res.ballot_no === data?.candidacy_set[0].ballot_no
        );

        if (filterBallotNo?.[0] !== undefined && parseBallotToInt > 11) {
          setFromIndex(lastEleven[0].ballot_no - 1);
          setToIndex(lastEleven[10].ballot_no);
        } else {
          setFromIndex(parseBallotToInt > 11 ? parseBallotToInt - 6 : 0);
          setToIndex(parseBallotToInt > 11 ? parseBallotToInt + 5 : 11);
        }
      }
    }

    return () => {
      setIsMounted(false);
    };
  }, [isMounted, data, lastEleven, parseBallotToInt]);

  const checkByContestName = () => {
    switch (data?.candidacy_set[0].contest?.display_name) {
      case "President":
        return `${basePath}elections/2022/races/president-vice-president`;
      case "Vice President":
        return `${basePath}elections/2022/races/president-vice-president`;
      case "Senator":
        return `${basePath}elections/2022/races/senator`;
      default:
        if (data?.candidacy_set[0].contest.scope === "LOCAL") {
          return `${basePath}elections/2022/metro-manila`;
        }
    }

    return basePath;
  };

  const shareMessage = () => {
    switch (data?.candidacy_set[0].contest?.display_name) {
      case "President":
        return `Partial, official 2022 presidential and vice presidential election results #PHVote #WeDecide #PHVoteResults `;
      case "Vice President":
        return `Partial, official 2022 presidential and vice presidential election results #PHVote #WeDecide #PHVoteResults`;
      case "Senator":
        return `Partial, official 2022 senatorial election results #PHVote #WeDecide #PHVoteResults`;
      default:
        return `Candidates for local – 2022 Philippine elections #PHVote #WeDecide`;
    }
  };

  const renderCandidacies = () => {
    const domStyle = (val, container) => {
      if (data.wp_slug === val.wp_slug) {
        return `${container} ${styles.highlight}`;
      } else {
        return `${container}`;
      }
    };

    if (candidates) {
      return candidates.results.slice(fromIndex, toIndex).map((res) => {
        return (
          <Link key={res.ballot_no} href={res.wp_slug} passHref>
            <div className={styles.widgetContainer_candidates_items}>
              <div
                className={domStyle(
                  res,
                  styles.widgetContainer_candidates_items_num
                )}
              >
                {res.ballot_no}
              </div>
              <div
                className={domStyle(
                  res,
                  styles.widgetContainer_candidates_items_name
                )}
              >
                <h3>{res.raw_name}</h3>
              </div>
            </div>
          </Link>
        );
      });
    } else {
      return "Loading...";
    }
  };

  const renderTitle = () => {
    if (data.candidacy_set[0].contest.scope === "NATIONAL") {
      return `${contestName}`;
    }

    const candidate = candidates?.results[0];
    const district = candidate.contest?.district?.name;
    const city = candidate.contest?.city?.name;
    const province = candidate.contest?.province?.name;

    return `${district || ""} ${city || province || ""}`;
  };

  return (
    <div className={styles.widgetContainer}>
      <div className={styles.widgetContainer_header}>
        <div className={styles.headerWrapper}>
          <h3 className={styles.title}>{renderTitle()}</h3>
          <div className={styles.socialsContainer_desktop}>
            <WidgetShare
              url={checkByContestName()}
              fbQuote={shareMessage()}
              tWQuoute={shareMessage()}
              toolTipId={"toolTip_Default"}
              isMounted={isMounted}
            />
          </div>
        </div>
        <h5 className={styles.sub}>
          {data.candidacy_set[0].contest.scope === "NATIONAL"
            ? "NATIONAL"
            : contestName}
        </h5>
      </div>
      <div className={styles.widgetContainer_candidates}>
        {renderCandidacies()}
      </div>
      {candidates !== null ? (
        <button
          className={styles.btnViewNationals}
          onClick={() => {
            window.location.href = url;
          }}
        >
          {`VIEW ${data.candidacy_set[0].contest.scope} ELECTIONS COVERAGE`}
        </button>
      ) : null}
      <div className={styles.socialsContainer_mobile}>
        <WidgetShare
          url={checkByContestName()}
          fbQuote={shareMessage()}
          tWQuoute={shareMessage()}
          toolTipId={"toolTip_Default"}
          isMounted={isMounted}
        />
      </div>
    </div>
  );
};

export default ContestWidget;
